// Tree titles come from the factor table; the form shows plurals for the long-standing types.
const TITLE_OVERRIDES = [
  { match: 'car', label: 'Cars' },
  { match: 'van', label: 'Vans' },
  { match: 'hgv', label: 'Trucks' },
];

export default function vehicleTypeDisplayName(name: string | null, title: string): string {
  const override = TITLE_OVERRIDES.find(({ match }) => name?.includes(match));
  return override ? override.label : title;
}
